import { OrderDetail } from '@insurance/api/requests'
import { createContext, useContext } from 'react'

type AccidentInsuranceValues = {
  isEditable: boolean
  order?: OrderDetail
}

const AccidentInsuranceContext = createContext<AccidentInsuranceValues>({
  isEditable: false
})

export const AccidentInsuranceProvider = ({
  children,
  ...values
}: React.PropsWithChildren<AccidentInsuranceValues>) => {
  return (
    <AccidentInsuranceContext.Provider value={values}>
      {children}
    </AccidentInsuranceContext.Provider>
  )
}

export const useAccidentInsuranceValues = () =>
  useContext(AccidentInsuranceContext)
